import { render, staticRenderFns } from "./Computadores.vue?vue&type=template&id=4a9b49ce"
import script from "./Computadores.vue?vue&type=script&lang=js"
export * from "./Computadores.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports